import { v4 as uuid } from "uuid";

import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IBadgeResource } from "../types";

export type IBadgeCreateMutationParameters = {
    name: string;
    template: string;
    uuid?: string;
};

export type IBadgeCreateMutationResult = IBadgeResource;

export const badgeCreateMutation: IApiMutationFunction<IBadgeCreateMutationParameters> = ({
    name,
    template,
    uuid: providedUuid,
}) => {
    return {
        method: "POST",
        url: "/badges",
        data: {
            name,
            template,
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useBadgeCreateMutation = createApiMutationHook<IBadgeCreateMutationParameters, IBadgeCreateMutationResult>(
    badgeCreateMutation,
);
